import { FormattedMessage } from 'react-intl'
import { target } from 'utils'
import {
  IncludedDiving,
  PriceConverter,
  PromotionLabel,
  TwoDatesFormat,
} from '../helpers'
import { ShopSlider } from '../search'
import PromotionCornerLabel from './PromotionCornerLabel'

export default function LiveaboardOperatorDealsCard({
  shop,
  handleClick,
  lastMinuteDeals,
}) {
  const onClick = () => {
    if(handleClick) {
      handleClick(shop)
    }
  }

  return (
    <div className='operator-item-wrapper' key={shop.url} onClick={onClick}>
      <a
        className='operator-item-card bordered-element'
        href={shop.url}
        target={target}
      >
        {lastMinuteDeals ? (
          <ShopSlider slug={shop.shopSlug} />
        ) : (
          <div className='img-wrapper'>
            <PromotionCornerLabel
              promotion={shop.promotion}
              price={shop.price}
              compareAtPrice={shop.compareAtPrice}
            />
            <span
              style={{
                backgroundImage: `url(${shop.backgrounds.DOSliderMobileLand})`,
              }}
              className='img'
            />
            {shop.promotion && (
              <p className='promo-title'>
                {shop.promotion.title.length > 50
                  ? `${shop.promotion.title.slice(0, 47)}...`
                  : shop.promotion.title}
              </p>
            )}
            <div className='overlay-bottom' />
          </div>
        )}

        <div className='info'>
          <strong className='shop-title'>{shop.shopTitle}</strong>
          <ul className='features'>
            <li>
              <i className='font-icons location-icon' />
              {shop.countryTitle}
            </li>
            <IncludedDiving
              numberOfDivesMax={shop.numberOfDivesMax}
              numberOfDivesMin={shop.numberOfDivesMin}
            />
            <li>
              <i className='font-icons calendar-icon' />
              <TwoDatesFormat dateFrom={shop.dateFrom} dateTo={shop.dateTo} />
            </li>
          </ul>
        </div>
        <div className='price-wrap'>
          <PromotionLabel
            promotion={shop.promotion}
            currency={shop.currency}
            price={shop.price}
            compareAtPrice={shop.compareAtPrice}
            showComparePrice
          />
          <span className='price'>
            <PriceConverter amount={shop.price} currency={shop.currency} />
          </span>
          <div className='price-details'>
            <span className='price-type'>
              <FormattedMessage
                id='per_person_for_trip'
                defaultMessage='per person per trip'
              />
            </span>
          </div>
        </div>
      </a>
    </div>
  )
}
